import Reflux from 'reflux';
import ShowData from 'shared/data/Show';
import ScheduleData from 'shared/data/Schedule';
import ListData from 'shared/data/List';
import { DisplayTypes } from 'shared/constants/FlowConstants';

const async = { asyncResult: true };
const GuestPassActions = Reflux.createActions({
  toggleGuestPass: async,
});

GuestPassActions.toggleGuestPass.listenAndPromise(
  (teamId, eventId, showId, value, displayType) => {
    let handler = ShowData.updateField;

    if (displayType === DisplayTypes.schedule)
      handler = ScheduleData.updateField;
    if (displayType === DisplayTypes.list) handler = ListData.updateField;

    return handler(teamId, eventId, showId, 'disableGuestPass', value);
  },
);

export default GuestPassActions;
